import {Component} from 'react';
import axios from "axios"
import Nav from "./../Nav";
import myconfig from "../../myconfig";

import { Pie,Line } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend,CategoryScale,LinearScale,LineElement,Title,PointElement} from 'chart.js';
import Swal from "sweetalert2";
Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
let source = axios.CancelToken.source();

class DashVehicleStatus extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            objs:[],
            objsload:false,
            totalveh:0,
            notoperation:0,
            operation:0,
            today:0,
            todayveh:0,
            ready:0,
            notready:0,
        }
    }
    fetcheddata = () => {
        let baseurl = myconfig.dashboardallocation;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsload: true,
                    totalveh:res.data.totalveh,
                    notoperation:res.data.notoperation,
                    operation:res.data.operation,
                    today:res.data.today,
                    todayveh:res.data.todayveh,
                    ready:res.data.ready,
                    notready:res.data.notready,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentDidMount() {
        this.fetcheddata()
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    chartpiereadyvsnotready=()=> {
        let data = {
            labels: ["Ready For Order", "Not Ready"],
            datasets: [
                {
                    label: 'Ready vs Not-ready',
                    data: [this.state.ready, this.state.notready],
                    backgroundColor: [
                        'rgba(0, 255, 0, 1)',
                        'rgba(255, 0, 0, 1)',
                    ],
                    borderColor: [
                        'rgba(0, 255, 0, 1)',
                        'rgba(255, 0, 0, 1)',
                    ],
                    borderWidth: 1,
                },
            ],
        };
        return (<>  <Pie data={data}/></>)
    }
    chartpieopevsnot=()=> {
        let data = {
            labels: ["Operational", "Not-operational"],
            datasets: [
                {
                    label: 'Ready vs Not-ready',
                    data: [this.state.operation, this.state.notoperation],
                    backgroundColor: [
                        'rgba(0, 255, 0, 1)',
                        'rgba(255, 0, 0, 1)',
                    ],
                    borderColor: [
                        'rgba(0, 255, 0, 1)',
                        'rgba(255, 0, 0, 1)',
                    ],
                    borderWidth: 1,
                },
            ],
        };
        return (<>  <Pie data={data}/></>)
    }
    tableready=()=> {
        let retdata = null;
        if(this.state.objsload) {
            let count=0;
            retdata = this.state.objs.readyfororder.map(value => {
                count=count+1;
                return <tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.loc}</td>
                    <td>{value.avl}</td>
                </tr>
            })
        }
        return (<>{retdata}</>)
    }
    tablecatagory=()=> {
        let retdata = null;
        if(this.state.objsload) {
            let count=0;
            retdata = this.state.objs.catagory.map(value => {
                count=count+1;
                return <tr>
                    <td>{count}</td>
                    <td>{value.type}</td>
                    <td>{value.count}</td>
                </tr>
            })
        }
        return (<>{retdata}</>)
    }
    chartline7dayorder=()=> {
        /*let label = [];
        let datavalue = [];
        this.state.sevendaykm.map(value => {
            label.push(value.label)
            datavalue.push(value.km)
        })*/
        let data = {
            labels: ["Monday","Tusday","Wensday","Thursday","Friday","Satruday","Sunday"],
            datasets: [
                {
                    label: "7 Day Order",
                    data: [1233,12323,223,2323,2323,2332,32323],
                    fill: true,
                    backgroundColor: "rgba(0,255,0,1)",
                    borderColor: "rgba(0,255,0,1)",
                }
            ]
        };
        return (<Line data={data}/>)
    }
    render() {
        return (
            <>
                <Nav type="dashvehiclestatus"/>
                <div className="content-wrapper" style={{minHeight: '92px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Vehicle Status</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Dashboard Status</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-info">
                                        <div className="inner">
                                            <h3>{this.state.totalveh}</h3>
                                            <p>Total Truck</p>
                                        </div>
                                        <div className="icon">
                                        </div>
                                        <a href="#" className="small-box-footer"><i
                                            className="fas fa-arrow-circle-right"/></a>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-success">
                                        <div className="inner">
                                            <h3>{this.state.operation}</h3>
                                            <p>Operation</p>
                                        </div>
                                        <div className="icon">
                                        </div>
                                        <a href="#" className="small-box-footer"><i
                                            className="fas fa-arrow-circle-right"/></a>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-danger">
                                        <div className="inner">
                                            <h3>{this.state.notoperation}</h3>
                                            <p>Not-Operational</p>
                                        </div>
                                        <div className="icon">

                                        </div>
                                        <a href="#" className="small-box-footer"><i
                                            className="fas fa-arrow-circle-right"/></a>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-secondary">
                                        <div className="inner">
                                            <h3>{this.state.today} [q]</h3>
                                            <p>Today Allocated</p>
                                        </div>
                                        <div className="icon">
                                        </div>
                                        <a href="#" className="small-box-footer"><i
                                            className="fas fa-arrow-circle-right"/> {this.state.todayveh} Truck</a>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                Ready for Order vs Not-ready
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartpiereadyvsnotready()}
                                        </div>
                                    </div>
                                </section>
                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                Ready for order
                                            </h3>
                                        </div>
                                        <div className="card-body table-responsive p-0 m-0" style={{height: '485px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Plate No </th>
                                                    <th>Status</th>
                                                    <th>Current Location</th>
                                                    <th>Update Time</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tableready()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                Operational Vs Not-Operational
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartpieopevsnot()}
                                        </div>
                                    </div>
                                </section>
                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                Truck by Category
                                            </h3>
                                        </div>
                                        <div className="card-body table-responsive p-0 m-0" style={{height: '485px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Category </th>
                                                    <th>Count</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablecatagory()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default DashVehicleStatus;
